import { render, staticRenderFns } from "./epb-confirm-modal.component.vue?vue&type=template&id=669d1d20&scoped=true"
import script from "./epb-confirm-modal.component.vue?vue&type=script&lang=ts"
export * from "./epb-confirm-modal.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-confirm-modal.component.vue?vue&type=style&index=0&id=669d1d20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669d1d20",
  null
  
)

export default component.exports